import React from 'react';
import { SubmitErrorHandler, UseFormReturn } from 'react-hook-form';
import { PrimaryButtonMandatory, SecondaryButtonMandatory } from '../Modal/Modal.view';
import { SubmitHandler } from 'react-hook-form/dist/types/form';
import { Modal } from '../Modal';
import { ModalControllerProps } from '../Modal/Modal.controller';
import { Portal } from '../Portal';

export type FormModalViewProps = Omit<
  ModalControllerProps,
  | 'primaryButtonTitle'
  | 'secondaryButtonTitle'
  | 'primaryButtonLoading'
  | 'secondaryButtonLoading'
  | 'primaryButtonAction'
  | 'secondaryButtonAction'
  | 'secondaryButtonDisabled'
  | 'primaryButtonColor'
  | 'secondaryButtonColor'
> & {
  //
  formInstance: UseFormReturn;
  hideCloseIcon?: boolean;
  loading: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: SubmitHandler<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onError?: SubmitErrorHandler<any>;
  submitText: string;
  useResetFormButton?: boolean;
};

export const FormModalView = (props: FormModalViewProps): JSX.Element => {
  const primaryButton = !props.footerContent
    ? ({
        primaryButtonTitle: props.submitText,
        primaryButtonLoading: props.loading,
        primaryButtonDisabled: props.primaryButtonDisabled || props.loading,
        primaryButtonAction: props.formInstance.handleSubmit(props.onSubmit, props.onError),
        primaryButtonType: 'button'
      } as PrimaryButtonMandatory)
    : {};

  const secondaryButton = props.useResetFormButton
    ? ({
        secondaryButtonTitle: 'Reset',
        secondaryButtonLoading: props.loading,
        secondaryButtonAction: () => props.formInstance.reset(),
        secondaryButtonDisabled: props.loading,
        secondaryButtonType: 'reset'
      } as SecondaryButtonMandatory)
    : {};

  const copiedArgs = {
    showCloseIcon: props.showCloseIcon,
    title: props.title,
    onClose: props.onClose,
    size: props.size,
    ...(props.closeOnClickOutside !== undefined
      ? { closeOnClickOutside: props.closeOnClickOutside }
      : { closeOnClickOutside: !props.showCloseIcon }),
    ...(props.closeOnEsc !== undefined ? { closeOnEsc: props.closeOnEsc } : {})
  };

  return (
    <Portal>
      <form>
        <Modal
          {...copiedArgs}
          omitPortal
          showCloseIcon={!props.loading && props.showCloseIcon}
          {...primaryButton}
          {...secondaryButton}
          footerContent={props.footerContent}>
          {props.children}
        </Modal>
      </form>
    </Portal>
  );
};
